export default {
  image: { borderRadius: '6px' },
  pointer: { cursor: 'pointer' },
};
